export default {
  songkick: {
    api_key: 'ulyeiIqDOQotEFU8'
  },
  spotify: {
    client_id: '686bd8ca39d842408829726eede611df'
  }
}